import { FormControl, FormHelperText, Input, InputLabel, TextFieldProps } from '@mui/material';
import { JSX } from 'react';
import { PatternFormat, PatternFormatProps } from 'react-number-format';

interface DateTextFieldProps
  extends Omit<TextFieldProps, 'onChange'>,
    Pick<PatternFormatProps, 'allowEmptyFormatting'> {
  onChange: (value: string) => void;
}

/**
 * A text field for entering dates.
 */
const DateTextField = ({
  label,
  error,
  value,
  helperText,
  onChange,
  allowEmptyFormatting = true,
}: DateTextFieldProps): JSX.Element => (
  <FormControl
    fullWidth
    error={error}
    sx={{
      '& .MuiInput-root': {
        marginTop: '24px',
        borderRadius: '4px',
        overflow: 'hidden',
      },
      '& .Mui-error.MuiInput-root': {
        borderColor: 'error.main',
      },
    }}
  >
    <InputLabel shrink>{label}</InputLabel>
    <PatternFormat
      error={error}
      format="####/##/##"
      mask={['Y', 'Y', 'Y', 'Y', 'M', 'M', 'D', 'D']}
      customInput={Input}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      value={value as any}
      allowEmptyFormatting={allowEmptyFormatting}
      onValueChange={({ formattedValue }): void => {
        onChange(formattedValue);
      }}
    />
    <FormHelperText>{helperText}</FormHelperText>
  </FormControl>
);

export default DateTextField;
